import { useState } from 'react'
import { Plus } from 'lucide-react'

export default function CurrentsView({ currents, circleId, onCreateCurrent, onOpenLoom, onExportCurrent }: any) {
  const [newName, setNewName] = useState('')
  const [newDesc, setNewDesc] = useState('')

  async function create() {
    if (!newName.trim() || !circleId) return
    await onCreateCurrent(newName.trim(), newDesc.trim() || undefined)
    setNewName('')
    setNewDesc('')
  }

  if (!circleId) {
    return (
      <div className="paper p-8 rounded-2xl text-center">
        <div className="font-serif text-xl mb-2">Currents live inside circles</div>
        <div className="text-sm text-[#5c4633]">Join or create a circle to name and tend interpretive threads together. Currents are how the commons shows aggregate patterns without ever creating stereotypes.</div>
      </div>
    )
  }

  return (
    <div>
      <div className="flex items-end justify-between mb-4">
        <div>
          <div className="font-serif text-2xl">Currents</div>
          <div className="text-sm text-[#5c4633]">Human-named interpretive threads. Structural patterns only.</div>
        </div>
        <button onClick={() => onExportCurrent?.(null)} className="text-xs px-3 py-1.5 border border-[#d4c9b8] rounded">Export full loom</button>
      </div>

      {/* Name a new current */}
      <div className="paper p-4 rounded-2xl mb-6">
        <div className="text-xs uppercase tracking-widest text-[#5c4633] mb-2">Name a current (a thread worth following)</div>
        <input value={newName} onChange={e=>setNewName(e.target.value)} placeholder="e.g. Grandmothers as hidden referral infrastructure" className="w-full text-sm p-2 rounded border border-[#d4c9b8] mb-2" />
        <input value={newDesc} onChange={e=>setNewDesc(e.target.value)} placeholder="Short description of the shape you are seeing (optional)" className="w-full text-sm p-2 rounded border border-[#d4c9b8] mb-3" />
        <button onClick={create} disabled={!newName.trim()} className="flex items-center gap-2 text-sm px-4 py-1.5 rounded bg-[#3f2e1e] text-[#f8f5f0] disabled:opacity-40"><Plus className="w-3.5 h-3.5"/> Name this current</button>
      </div>

      {currents.length === 0 && (
        <div className="text-sm text-[#5c4633]">No currents named yet. When several observations feel like they belong to the same underlying shape, name the shape. Then deliberately place observations into it.</div>
      )}

      <div className="space-y-4">
        {currents.map((c: any) => (
          <div key={c.id} className="paper rounded-2xl p-5">
            <div className="flex justify-between items-start">
              <div>
                <div className="font-medium text-lg">{c.name}</div>
                {c.description && <div className="text-sm text-[#5c4633] mt-0.5">{c.description}</div>}
              </div>
              <div className="text-right text-xs text-[#5c4633]">
                {c.obs_count || 0} placed<br />
                <button onClick={() => onOpenLoom(c.id)} className="underline">open loom</button>
              </div>
            </div>

            <div className="mt-4 flex gap-2">
              <button onClick={() => onOpenLoom(c.id)} className="text-xs px-3 py-1 rounded border border-[#8b5e3c]">View observations &amp; perspectives in this current</button>
              <button onClick={() => onExportCurrent(c.id)} className="text-xs px-3 py-1 rounded border border-[#d4c9b8]">Export packet</button>
            </div>
          </div>
        ))}
      </div>

      <div className="mt-8 text-xs text-[#5c4633] max-w-prose">
        These are not categories of people. They are shapes of situations that multiple workers have recognized as worth holding together. The value is in the deliberate act of placing observations side by side and seeing what becomes visible.
      </div>
    </div>
  )
}
